<template>
	<div class="Start">
		<StartSessie></StartSessie>
	</div>
</template>

<script>

// @ is an alias to /src
import StartSessie from '@/components/StartSessie.vue'

export default {
	name: 'start',
	components: {
		StartSessie
	}
}
</script>
